// extracted by mini-css-extract-plugin
export default {"Center":"Footer_Center__NZOZm","bold":"Footer_bold__nVeCP","footercolor":"Footer_footercolor__6XcFj","Footer":"Footer_Footer__6OD3Q","footer_link":"Footer_footer_link__OiWSx"};